import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './Quantity.module.scss';

const Quantity = ({ how = 0, from = 100 }) => {
  return (
    <Text className={classes.quantity}>
      <Text className={classes.current} weight="b">
        {how}
      </Text>
      <Text className={classes.max} weight="b">
        &nbsp;{` /${from}`}
      </Text>
    </Text>
  );
};

Quantity.propTypes = {
  how: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Quantity;
